(async () => {
  async function fetchPlans() {
    const wrapper = document.querySelector(".slider-container-wrapper");
    const loader = document.createElement("div");
    loader.className = "loader";
    loader.innerText = "Loading...";
    wrapper.appendChild(loader);

    // const productDataId = document.querySelector(".recurrpay-widget-container")?.dataset.productId;
    // const url = `https://orbit-prototype.recurpay.com/storefront/api/2024-07/products/${productDataId}/plans`;
    const container = document.querySelector(".recurrpay-widget-container");
    if (!container?.dataset.productId) {
      console.error("Product ID not found in widget container");
      return;
    }
    const productDataId = container.dataset.productId;
    const apiBase = container.dataset.apiUrl || 'https://orbit-prototype.recurpay.com';
    const url = `${apiBase}/storefront/api/2024-07/products/${productDataId}/plans`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { accept: 'application/json', 'content-type': 'application/json' },
      });
      const data = await response.json();
      loader.remove();
      return data.data;
    } catch (error) {
      loader.innerText = "Failed to load plans.";
      console.error(error);
      return null;
    }
  }

  const productPlansData = await fetchPlans();
  if (!productPlansData?.plans?.length) {
    document.querySelector(".recurrpay-widget-container").innerText = "There's no plan";
    return;
  }

  const sliderContainer = document.getElementById("slider");
  sliderContainer.innerHTML = '';

  const indicator = document.createElement('div');
  indicator.className = 'slider-indicator';
  indicator.id = 'indicator';
  // indicator.innerHTML = `
  //   <strong>${productPlansData.plans[0].name.split(" ")[0]}</strong>
  //   <span>Months</span>
  // `;
  const firstPlanName = productPlansData.plans[0].name;
  const nameParts = firstPlanName.split(" ");
  const displayName = nameParts.length > 0 ? nameParts[0] : firstPlanName;
  indicator.innerHTML = `
    <strong>${displayName}</strong>
    <span>Months</span>
  `;
  sliderContainer.appendChild(indicator);

  productPlansData.plans.forEach(plan => {
    const sp = plan.selling_plans[0];
    const option = document.createElement('div');
    option.className = 'slider-option';
    option.dataset.planId = sp.selling_plan_id.split('/').pop();
    option.dataset.planDiscount = sp.pricing_polices[0]?.discount?.type === "percentage"
      ? sp.pricing_polices[0].discount.value
      : 0;
    option.innerText = plan.name.split(" ")[0];
    sliderContainer.appendChild(option);
  });

    const userCountry = window.Shopify?.country || 'AU';
    const currencyCode = window.Shopify?.currency?.active || 'AUD';
    const userLocale = navigator.language || 'en-AU';
  
    function formatCurrency(amount) {
      if (currencyCode === 'AUD') {
          return amount.toLocaleString('en-AU', {
              style: 'currency',
              currency: 'AUD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
      } else {
          return amount.toLocaleString(userLocale, {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
      }
    }

  const container = document.getElementById('slider');
  const options = Array.from(container.querySelectorAll('.slider-option'));
  const indicatorEl = document.getElementById('indicator');

  let isDragging = false;
  let startX = 0;
  let currentLeft = 0;

  function moveIndicatorToIndex(index) {
    requestAnimationFrame(() => {
      const containerRect = container.getBoundingClientRect();
      if (!containerRect.width || !options.length) return;

      const optionWidth = containerRect.width / options.length;
      const targetLeft = optionWidth * index + optionWidth / 2 - indicatorEl.offsetWidth / 2;
      currentLeft = targetLeft;
      indicatorEl.style.left = `${targetLeft}px`;
      indicatorEl.querySelector('strong').innerText = options[index].innerText;

      const widgetButton = document.querySelector(".widget-button-container button");
      if (widgetButton) widgetButton.dataset.sellingPlanId = options[index].dataset.planId;
      options.forEach(option => {
        option.classList.remove("active");
      })
      options[index].classList.add("active");

      const mainProdTotalPrice = parseFloat(document.querySelector(".widget-payment-wrapper").dataset.mainProdTotalPrice.replace(/,/g, ''));
      const discount = +options[index].dataset.planDiscount / 100;
      const discountedPrice = mainProdTotalPrice * (1 - discount);

      const monthlyPriceText = document.querySelector(".monthly-payment-new-price");
      if (monthlyPriceText) monthlyPriceText.innerText = formatCurrency(discountedPrice);
    });
  }

  function snapToNearest() {
    const containerRect = container.getBoundingClientRect();
    const optionWidth = containerRect.width / options.length;
    const centerX = currentLeft + indicatorEl.offsetWidth / 2;
    let closestIndex = 0;
    let closestDist = Infinity;

    options.forEach((_, index) => {
      const optionCenter = optionWidth * index + optionWidth / 2;
      const dist = Math.abs(centerX - optionCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = index;
      }
    });

    moveIndicatorToIndex(closestIndex);
  }

  // Interaction: Click
  options.forEach((opt, index) => {
    opt.addEventListener('click', () => moveIndicatorToIndex(index));
  });

  // Drag support
  indicatorEl.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.clientX - currentLeft;
    indicatorEl.classList.add('dragging');
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const containerRect = container.getBoundingClientRect();
    let newLeft = e.clientX - startX;
    const min = 0;
    const max = containerRect.width - indicatorEl.offsetWidth;
    currentLeft = Math.max(min, Math.min(max, newLeft));
    indicatorEl.style.left = `${currentLeft}px`;
  });

  document.addEventListener('mouseup', () => {
    if (isDragging) {
      isDragging = false;
      indicatorEl.classList.remove('dragging');
      snapToNearest();
    }
  });

  const stairsRadios = document.querySelectorAll('input[name="stairs"]');
  const stairsCasePriceText = document.querySelector(".stairs-case-price");
  if (stairsCasePriceText && stairsRadios.length) {
    const priceNum = parseFloat(stairsCasePriceText.innerText.replace('$', ''));
    const recurrpayBtn = document.querySelector(".recurrpay-widget-container button.widget-atc-button");
    const stairCaseProduct = recurrpayBtn?.dataset.stairsProductId;

    stairsRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        if (radio.value === "yes") {
          stairsCasePriceText.innerText = formatCurrency(priceNum);
          recurrpayBtn.dataset.stairsProductId = stairCaseProduct;
        } else {
          stairsCasePriceText.innerText = formatCurrency(0);
          recurrpayBtn.dataset.stairsProductId = "";
        }
      });
    });
  }

const locationRadios = document.querySelectorAll('input[name="location"]');
const locationCasePriceText = document.querySelector(".location-avialability-text");
const recurrpayBtn = document.querySelector(".recurrpay-widget-container button.widget-atc-button");

if (locationCasePriceText && locationRadios.length && recurrpayBtn) {
  locationRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;

      const availability = recurrpayBtn.dataset.productAvailability?.toLowerCase() || '';

      // Run this code regardless of availability, but only block enabling if truly unavailable
      if (availability === "true" || availability === "available" || availability === "") {
        if (radio.value === "yes") {
          locationCasePriceText.classList.add("active");
          recurrpayBtn.disabled = false;
        } else if (radio.value === "no") {
          locationCasePriceText.classList.remove("active");
          recurrpayBtn.disabled = true;
        }
      } else {
        // If product not available
        recurrpayBtn.disabled = true;
      }
    });
  });
}


  requestAnimationFrame(() => {
    moveIndicatorToIndex(0);
  });

  window.addEventListener('resize', snapToNearest);
})();
